import { render, staticRenderFns } from "./DriveGroupManager.vue?vue&type=template&id=6dc5d622&scoped=true"
import script from "./DriveGroupManager.vue?vue&type=script&lang=js"
export * from "./DriveGroupManager.vue?vue&type=script&lang=js"
import style0 from "./DriveGroupManager.vue?vue&type=style&index=0&id=6dc5d622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5d622",
  null
  
)

export default component.exports